export default "__VITE_ASSET__D45Dyy1J__"